import type { FaireProductEntity } from "../../entity_types/product";

export const p_qbqntuwu3h: FaireProductEntity = {
  token: "p_qbqntuwu3h",
  type: "product",
  name: "Handblown Mexican Highball Glasses - Clear",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/18af2564ca422a7ca53eaa51c53158f99207edf5ddebf1f3ebed049aae9dd9ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7de620c1b6bd7c7e272b58058a1095507d821313b118a9239126b1d35d97a007.jpeg",
    "https://cdn.faire.com/fastly/277ca0245951e4d7da2b144ed46d6193f8d6774247ee7639e5a32a0339aee963.jpeg",
    "https://cdn.faire.com/fastly/333d3e3a7074d0337a1c8629160301f2ae4ca06f69144c2362721ac2b376fdfe.jpeg",
    "https://cdn.faire.com/fastly/daa2bfc6e62c9e0536a5db12f97f69f720eabcae92947971f413df523515a3c7.jpeg",
    "https://cdn.faire.com/fastly/1bcebd5ad5fcea3a0fec801f1b2d3ff6de23c4db09acd3b31bb006d16e232d99.jpeg",
  ],
  priceDollars: 8.25,
  description:
    "**Packaged in sets of 4 as shown; 16 single glasses in a master (4 boxes of 4 glasses)**\n\nIntroducing our Handblown Mexican Glasses in Clear - the perfect match for simple, understated, and no-fuss drinks. Sustainably handcrafted by our talented glassblowing artisans in Jalisco, Mexico, each glass is meticulously shaped while molten hot, preserving its distinctive character. Available in sets of 4 for both short and highball sizes, because great drinks are meant to be enjoyed together. Elevate your drinking experience with these exquisite handblown glasses. Cheers to sustainability and craftsmanship!\n\nBe sure to check out our entire Clear Mexican Glassware Collection, including Short DOF Glasses, Shooter Glasses, Margarita Glasses, and a matching Pitcher! \n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nCapacity:\n500ml / 16 oz\n\nDimensions:\nEach Glass - 6.25'' tall x 2.5'' diameter\n",
  tags: [],
  msrpDollars: 16.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:55.150Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
